export const roundDecimalNumberToInteger = (value) => {
  if (typeof value !== 'number') throw new Error('only number accepted');

  const valueToString = String(value);
  const valueSplitted = valueToString.split('.');

  if (valueSplitted.length === 1) return value;

  const decimalValue = valueSplitted[1];
  const decimalWithZeroOnEnd = decimalValue.padEnd(2, 0);
  const getTwoDecimalPlaces = decimalWithZeroOnEnd.substring(0, 2);
  const decimalToNumber = Number(getTwoDecimalPlaces);
  const decimalRule = 51;

  if (decimalToNumber >= decimalRule) return Math.ceil(value);

  return Math.floor(value);
};
